import { useState, Dispatch, SetStateAction, useCallback } from 'react';
import { Row, Col, Button, Spinner } from "react-bootstrap";
import ConfirmationModal from "../../../components/containers/ConfirmationModal";
import { MatchAdmin } from "../../../models/interfaces/Match";
import { Stat, MatchSegmentStats } from '../../../models/interfaces/Stat';
import UploadStatCSV from "../UploadStatCSV";

interface Props {
    matchAdmin: MatchAdmin
    matchStatsList: MatchSegmentStats[];
    triggerUpdatedMatchStats: () => void;
}

export default function BulkStatRow({ matchAdmin, matchStatsList, triggerUpdatedMatchStats }: Props) {
    const [isHandlingDelete, setIsHandlingDelete] = useState(false)
    const [isConfirmingDelete, setIsConfirmingDelete] = useState(false) 
    const removeStats = useCallback(() => {
        setIsHandlingDelete(true)
        const allStats = matchStatsList.reduce((statList, matchSegmentStats) => {
            return statList.concat(matchSegmentStats.stats)
        }, new Array<Stat>())
        matchAdmin.removeStats(allStats).finally(() => {
            setIsConfirmingDelete(false)
            triggerUpdatedMatchStats()
            setIsHandlingDelete(false)
        })
    }, [matchAdmin, matchStatsList])

    const hideModal = () => {
        setIsConfirmingDelete(false)
    }
    return (
            isHandlingDelete ? <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
            :
            <>
            <Row className="text-center py-1"><Col><h6>Bulk Operations</h6></Col></Row>
        <Row>
            <Col>
                <UploadStatCSV matchAdmin={matchAdmin} />
            </Col>
            <Col className="text-center">
                <Button onClick={() => {
                    setIsConfirmingDelete(true)
                }}>Remove All Stats</Button>
                <ConfirmationModal 
                    shouldShow={isConfirmingDelete}
                    onHideModal={hideModal}
                    handleSubmit={removeStats}
                    title="Remove all stats?"
                    btnText="Confirm"
                />
            </Col>
        </Row>
        </>
        )
}